import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { PaymentPlanType } from "../types/General";
import { isString, isValidInput } from "../utils/validations";

type props = {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;

  handleSubmit: () => void;
  applicationStatus: string;
  handleApprovalStatus: (event: SelectChangeEvent) => void;
  paymentPlan: string;
  handlePaymentPlan: (event: SelectChangeEvent) => void;
  paymentPlansList: PaymentPlanType[];
  setPaymentPlan: Dispatch<SetStateAction<string>>;
  setApplicationStatus: Dispatch<SetStateAction<string>>;
  setRejectionReson: Dispatch<SetStateAction<string>>;
  rejectionReason: string;
};
export const ApplicationApprovalModal = ({
  openModal,
  setOpenModal,

  handleSubmit,
  applicationStatus,
  handleApprovalStatus,
  paymentPlan,
  handlePaymentPlan,
  paymentPlansList,
  setPaymentPlan,
  setApplicationStatus,
  setRejectionReson,
  rejectionReason,
}: props) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#ffff",
    boxShadow: 24,
    p: 6,
    borderRadius: 3,
    outline: "none",
  };
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="logout_mdl"
    >
      <Box sx={style}>
        <IconButton
          onClick={() => {
            setOpenModal(false);
            setPaymentPlan("default");
            setApplicationStatus("default");
          }}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#252525",
          }}
        >
          <CloseIcon />
        </IconButton>

        <div className="control_group w_100">
          <label>Approval Status</label>
          <Select
            fullWidth
            labelId="visaType"
            id="visaType"
            value={applicationStatus}
            onChange={handleApprovalStatus}
          >
            <MenuItem disabled value="default">
              Select
            </MenuItem>
            <MenuItem value={"APPROVE"}>Approve</MenuItem>
            <MenuItem value={"REJECT"}>Reject</MenuItem>
          </Select>
        </div>

        {applicationStatus === "APPROVE" ? (
          <div className="control_group w_100" style={{ marginTop: "16px" }}>
            <label>Select Payment Plan</label>
            <Select
              fullWidth
              labelId="paymentPlan"
              id="paymentPlan"
              value={paymentPlan}
              onChange={handlePaymentPlan}
            >
              <MenuItem disabled value="default">
                Select
              </MenuItem>
              {paymentPlansList?.length
                ? paymentPlansList?.map((item) => {
                    return (
                      <MenuItem value={item?.id} key={item?.id}>
                        {item?.plan_name || "-"}
                      </MenuItem>
                    );
                  })
                : null}
            </Select>
          </div>
        ) : null}

        {applicationStatus === "REJECT" ? (
          <div className="control_group w_100" style={{ marginTop: "16px" }}>
            <label>Rejection Reason</label>

            <TextField
              variant="outlined"
              placeholder="Rejection Reason"
              fullWidth
              hiddenLabel
              className="text_field"
              name="document_name"
              id="document_name"
              inputProps={{ maxLength: 200 }}
              multiline
              minRows={3}
              maxRows={4}
              value={rejectionReason}
              onChange={(val) => {
                if (
                  isValidInput(val.target.value) &&
                  isString(val.target.value)
                ) {
                  setRejectionReson(val.target.value);
                }
              }}
            />
          </div>
        ) : null}

        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "center",
            paddingTop: "20px",
          }}
        >
          <Button
            className="btn btn_blue"
            sx={{ minWidth: "100px" }}
            // sx={{ color: "#252525", border: "1px solid #252525" }}
            onClick={() => {
              setOpenModal(false);
              setPaymentPlan("default");
              setApplicationStatus("default");
            }}
          >
            Close
          </Button>
          <Button
            className="btn btn_blue"
            sx={{ minWidth: "100px" }}
            // sx={{ color: "#252525", border: "1px solid #252525" }}
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
